export default "__VITE_ASSET__BMmDGTJn__"